import { ReactElement } from 'react';
import SupportingDocuments from '@components/FVSPage/SupportingDocuments';
import { fvsInfoDisplayObject } from '@services/FormFieldConfig';

function FVSStep21(): ReactElement {
  return (
    <>
      <SupportingDocuments displayObject={fvsInfoDisplayObject} currentStepNo="step21" />
    </>
  );
}

export default FVSStep21;
